import { render, staticRenderFns } from "./StickyAskUsBtn.vue?vue&type=template&id=5f105407&"
import script from "./StickyAskUsBtn.vue?vue&type=script&lang=js&"
export * from "./StickyAskUsBtn.vue?vue&type=script&lang=js&"
import style0 from "./StickyAskUsBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
